import { render, staticRenderFns } from "./CorporateVendorList.vue?vue&type=template&id=274b6cfa"
import script from "./CorporateVendorList.vue?vue&type=script&lang=js"
export * from "./CorporateVendorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports